<script>
    import _ from 'lodash'

    export default {
        props: {
            object: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                value: null
            }
        },
        watch: {
            object: {
                handler () {
                    this.predicate()
                },
                deep: true
            }
        },
        created () {
            this.predicate()
        },
        methods: {
            predicate () {
                this.value = _.findKey(this.object, value => value === true)
            }
        },
        render () {
            return this.$scopedSlots.default({
                value: this.value
            })
        }
    }
</script>
